import type { ManagerList } from '../managerLists/types'
import { sicilKey, type AgendaParticipant } from './types'

/**
 * Grup daveti: listenin kişilerini davetlilere katar; yeni gelenler sona eklenir. Zaten davetli olan
 * sicil — tek tek ya da başka bir listeyle eklenmiş — **atlanır**: aynı kişi iki kez davet edilmez.
 * Karşılaştırma {@link sicilKey} iledir; liste sicili 8 haneye tamamlanmış, kişi seçicininki
 * tamamlanmamış gelebilir.
 *
 * <p>Eklenen kişi listenin kimliğini taşır (`AGENDA_PARTICIPANT.MANAGER_LIST_ID`, analist 19.10.2026); zaten
 * davetli olan atlandığı için etiketi değişmez. Kişiler yine tek tek görünür ve tek tek çıkarılabilir.
 *
 * <p>Eklenecek kimse yoksa **aynı dizi** döner — çağıran değişiklik yokken formu kirletmez.
 */
export function withListMembers(
  value: AgendaParticipant[],
  list: ManagerList,
): { next: AgendaParticipant[]; skipped: number } {
  const seen = new Set(value.map((p) => sicilKey(p.employeeId)))
  const added: AgendaParticipant[] = []
  let skipped = 0
  for (const p of list.people) {
    const key = sicilKey(p.employeeId)
    if (seen.has(key)) {
      skipped++
      continue
    }
    seen.add(key)
    added.push({
      employeeId: p.employeeId,
      firstName: p.firstName,
      lastName: p.lastName,
      businessMail: p.businessMail,
      jobTitleTr: p.jobTitleTr,
      jobTitleEn: p.jobTitleEn,
      managerListId: list.id,
    })
  }
  return { next: added.length > 0 ? [...value, ...added] : value, skipped }
}
